import { render, staticRenderFns } from "./BoxConfirmaLoteRegistros.vue?vue&type=template&id=03bdcf4a&scoped=true&"
import script from "./BoxConfirmaLoteRegistros.vue?vue&type=script&lang=js&"
export * from "./BoxConfirmaLoteRegistros.vue?vue&type=script&lang=js&"
import style0 from "./BoxConfirmaLoteRegistros.vue?vue&type=style&index=0&id=03bdcf4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bdcf4a",
  null
  
)

export default component.exports